import React, { FC } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { useTranslation } from "Providers/TranslationProvider";
import { Alert, AlertTitle } from "@material-ui/lab";
import { px } from "Configs/theme";

interface Props {
	error: Error;
	children?: React.ReactNode;
}

const ErrorView: FC<Props> = (props) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<Box className={classes.main} padding={px.m}>
			<Alert severity="error">
				<AlertTitle>{t("ErrorView_Title")}</AlertTitle>
				{props.error.message}
			</Alert>
			{props.children}
		</Box>
	);
};

export default ErrorView;

const useStyles = makeStyles({
	main: {
		display: "flex",
		flexDirection: "column",
		flex: 1,
	},
});
